/*
 * Alaya Junior — Collection carousel arrows (Agenda 7)
 * Desktop prev/next controls over the existing scroll-snap track. Mobile keeps
 * native swipe; the arrows are hidden by CSS below 990px. Follows the theme's
 * existing custom-element pattern (see <load-more-button>).
 */
class CollectionCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.collection-carousel__track');
    this.prevButton = this.querySelector('[data-carousel-prev]');
    this.nextButton = this.querySelector('[data-carousel-next]');

    if (!this.track || !this.prevButton || !this.nextButton) return;

    this.prevButton.addEventListener('click', () => this.page(-1));
    this.nextButton.addEventListener('click', () => this.page(1));
    this._ticking = false;
    this.track.addEventListener(
      'scroll',
      () => {
        if (this._ticking) return;
        this._ticking = true;
        requestAnimationFrame(() => {
          this.refresh();
          this._ticking = false;
        });
      },
      { passive: true }
    );
    this._onResize = () => this.refresh();
    window.addEventListener('resize', this._onResize);

    this.refresh();
  }

  disconnectedCallback() {
    if (this._onResize) window.removeEventListener('resize', this._onResize);
  }

  page(direction) {
    this.track.scrollBy({
      left: direction * this.track.clientWidth * 0.8,
      behavior: 'smooth',
    });
  }

  refresh() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
    const overflows = maxScroll > 0;

    this.prevButton.disabled = !overflows || this.track.scrollLeft <= 0;
    this.nextButton.disabled = !overflows || this.track.scrollLeft >= maxScroll;
  }
}

if (!customElements.get('collection-carousel')) {
  customElements.define('collection-carousel', CollectionCarousel);
}
